import { MobileTabBar } from '../../components/MobileTabBar';
import { SideNav } from '../../components/SideNav';
import { ContentArea, Main, Shell } from './AppShell.styles';
import type { AppShellProps } from './AppShell.types';

export function AppShell({
  navItems,
  bottomNavItems,
  mobileNavItems,
  children,
  footer,
  navigationLabel,
}: AppShellProps) {
  return (
    <Shell>
      <SideNav items={navItems} bottomItems={bottomNavItems} navigationLabel={navigationLabel} />

      <ContentArea>
        <Main>{children}</Main>
        {footer}
      </ContentArea>

      <MobileTabBar items={mobileNavItems} navigationLabel={navigationLabel} />
    </Shell>
  );
}
